// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.OrderPre-Dialog-Pay {\n    width: 990px;\n    position: absolute;\n    top: -70px;\n}\n.OrderPre-Dialog-Pay .el-dialog__body {\n    flex-direction: column;\n}\n.OrderPre-Dialog-Pay .el-table--border {\n    border-radius: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
